/* eslint-disable logical-assignment-operators */
/* eslint-disable import/no-extraneous-dependencies */
/* eslint-disable no-unused-vars */
/* eslint-disable react/no-string-refs */

import {
    Accordion,
    AccordionDetails,
    AccordionSummary,
    Box,
    Button,
    Chip,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Table,
    TableBody,
    TableCell,
    TableHead,
    TableRow,
    Typography,
} from '@mui/material';
import moment from 'moment';
import React, { useEffect, useRef, useState } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import ClimbingBoxLoader from 'react-spinners/ClimbingBoxLoader';
import { v4 } from 'uuid';
import { useTranslation } from '../common/components/LocalizationProvider';
import PageLayout from '../common/components/PageLayout';
import TableShimmer from '../common/components/TableShimmer';
import '../common/tickets.css';
import { useAheadTimeThreshold } from '../common/util/permissions';
import { formatDate, isMobile } from '../common/util/utils';
import TableExitsReport from '../main/components/TableExitsReport';
import TimeUpdateBtn from '../main/components/TimeUpdateBtn';
import { useCatch, useEffectAsync } from '../reactHelper';
import scheduleReport from './common/scheduleReport';
import useReportStyles from './common/useReportStyles';
import ReceiptPrintView from './components/ReceiptPrintView';
import ReportFilter from './components/ReportFilter';
import ReportsMenu from './components/ReportsMenu';

import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { formatearFechaES } from './TicketReportPage';


const CortesCajaReportPage = () => {
    const navigate = useNavigate();
    const classes = useReportStyles();
    const t = useTranslation();

    const [user, setUser] = useState('');
    const [subusers, setSubusers] = useState([]);
    const [receipts, setReceipts] = useState([]);
    const [loading, setLoading] = useState(false);


    const handleSubmit = useCatch(async ({ deviceIds, groupIds, from, to, type }) => {
        window.filters = { deviceIds, groupIds, from, to, type };
        const query = new URLSearchParams({ from, to });
        deviceIds.forEach((deviceId) => query.append('deviceId', deviceId));
        groupIds.forEach((groupId) => query.append('groupId', groupId));
        query.append('user', parseInt(user));
        if (type === 'export') {
            //   handleDownload(`/api/reports/tickets/xlsx?${query.toString()}`);
            // window.location.assign(`/api/reports/tickets/xlsx?${query.toString()}`);
        } else if (type === 'mail') {
            //   const response = await fetch(`/api/reports/tickets/mail?${query.toString()}`);
            if (!response.ok) {
                throw Error(await response.text());
            }
        } else {
            console.log(query);

            await fetchReceiptss(query);
        }
    });

    const fetchReceiptss = async (query) => {
        try {
            setLoading(true);

            const response = await fetch(`/api/reports/recibos?${query.toString()}`, {
                headers: { Accept: 'application/json' },
            });

            if (!response.ok) {
                throw Error(await response.text());
            }

            const items = await response.json();

            setReceipts(items);   // 🔥 THIS was missing

        } finally {
            setLoading(false);
        }
    };

    const calculateReceiptSummary = (receipt) => {
        let totalPunishment = 0;
        let omittedSalidas = 0;
        let excusedTickets = 0;
        let countedTickets = 0;

        receipt.salidas.forEach((salida) => {

            const salidaOmitted = salida.excuse && salida.excuse.trim() !== '';

            if (salidaOmitted) {
                omittedSalidas++;
                return; // ignore entire salida
            }

            salida.tickets.forEach((ticket) => {

                const ticketExcused = ticket.excuse && ticket.excuse.trim() !== '';

                if (ticketExcused) {
                    excusedTickets++;
                    return;
                }

                if (ticket.difference > 0) {
                    totalPunishment += ticket.punishment;
                    countedTickets++;
                }
            });

        });

        return {
            totalPunishment,
            omittedSalidas,
            excusedTickets,
            countedTickets,
        };
    };



    useEffectAsync(async () => {
        const _subusers = await (await fetch('/api/users')).json();
        console.log(_subusers);

        setSubusers(_subusers);
    }, [])

    return (
        <PageLayout menu={< ReportsMenu />} breadcrumbs={['reportTitle', 'reportRoute']} >
            <div className={classes.container}>
                <div className={classes.containerMain}>
                    <div className={classes.header}>
                        <ReportFilter
                            handleSubmit={handleSubmit}
                            handleSchedule={() => { }}
                            customDayOnly={true}
                            ignoreDevice
                        >
                            <FormControl style={{ width: '20vw' }}>
                                <InputLabel>{t('settingsUsers')}</InputLabel>
                                <Select
                                    label={t('settingsUsers')}
                                    value={user}
                                    onChange={(event) => setUser(event.target.value)}
                                >
                                    <MenuItem value="">
                                        <em>--</em>
                                    </MenuItem>

                                    {subusers.map(s => (
                                        <MenuItem key={`user-${s.id}`} value={s.id}>
                                            {s.name}
                                        </MenuItem>
                                    ))}
                                </Select>

                            </FormControl>
                        </ReportFilter>
                    </div>

                    {loading && <ClimbingBoxLoader />}

                    {receipts.map((receipt) => {
                        const summary = calculateReceiptSummary(receipt);

                        return (
                            <Accordion key={receipt.id} sx={{ mt: 2 }}>
                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                    <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                                        <Typography fontWeight="bold">
                                            Recibo #{receipt.id} — {receipt.route} - {formatearFechaES(new Date(receipt.storedAt))}
                                        </Typography>

                                        <Box sx={{ display: 'flex', gap: 1 }}>

                                            <Chip
                                                label={`Registrado: $${receipt.total}`}
                                                color={summary.totalPunishment > 0 ? 'error' : 'success'}
                                            />
                                            <Chip
                                                label={`Calculado: $${summary.totalPunishment}`}
                                                color={summary.totalPunishment > 0 ? 'error' : 'success'}
                                            />

                                            <Chip
                                                label={`Salidas Omitidas: ${summary.omittedSalidas}`}
                                                color="warning"
                                                variant="outlined"
                                            />

                                            <Chip
                                                label={`Tickets Excusados: ${summary.excusedTickets}`}
                                                color="info"
                                                variant="outlined"
                                            />

                                            <Chip
                                                label={moment(receipt.storedAt).format('YYYY-MM-DD HH:mm')}
                                                variant="outlined"
                                            />

                                        </Box>

                                    </Box>
                                </AccordionSummary>

                                <AccordionDetails>

                                    {receipt.salidas.length === 0 && (
                                        <Typography color="text.secondary">
                                            No salidas
                                        </Typography>
                                    )}

                                    {receipt.salidas.map((salida) => {
                                        const totalPunishment = salida.tickets.reduce(
                                            (sum, t) => sum + t.punishment,
                                            0
                                        );
                                        const salidaOmitted = salida.excuse && salida.excuse.trim() !== '';

                                        const salidaPunishment = salidaOmitted
                                            ? 0
                                            : salida.tickets.reduce((sum, t) => {
                                                const ticketExcused = t.excuse && t.excuse.trim() !== '';
                                                if (ticketExcused) return sum;
                                                if (t.difference > 0) return sum + t.punishment;
                                                return sum;
                                            }, 0);

                                        return (
                                            <Accordion key={salida.id} sx={{ mb: 2, backgroundColor: salidaOmitted ? '#fff8e1' : 'inherit' }}>
                                                <AccordionSummary expandIcon={<ExpandMoreIcon />}>
                                                    <Box sx={{ display: 'flex', width: '100%', justifyContent: 'space-between' }}>
                                                        <Typography>
                                                            Salida #{salida.id}
                                                        </Typography>

                                                        <Box sx={{ display: 'flex', gap: 1 }}>

                                                            {salidaOmitted && (
                                                                <Chip label="OMITIDA" color="warning" />
                                                            )}

                                                            <Chip
                                                                label={`Importe: $${salidaPunishment}`}
                                                                color={salidaPunishment > 0 ? 'error' : 'success'}
                                                                size="small"
                                                            />

                                                        </Box>
                                                    </Box>
                                                </AccordionSummary>

                                                <AccordionDetails>

                                                    <Table size="small">
                                                        <TableHead>
                                                            <TableRow>
                                                                <TableCell>ID</TableCell>
                                                                <TableCell>Expected</TableCell>
                                                                <TableCell>Enter</TableCell>
                                                                <TableCell>Exit</TableCell>
                                                                <TableCell>Diff</TableCell>
                                                                <TableCell>Punishment</TableCell>
                                                                <TableCell>Excuse</TableCell>
                                                            </TableRow>
                                                        </TableHead>

                                                        <TableBody>
                                                            {salida.tickets.map((ticket) => (
                                                                <TableRow
                                                                    key={ticket.id}
                                                                    sx={{
                                                                        backgroundColor: ticket.punishment > 0 ? '#fff5f5' : 'inherit'
                                                                    }}
                                                                >

                                                                    <TableCell>{ticket.id}</TableCell>

                                                                    <TableCell>
                                                                        {moment(ticket.expectedTime).format('HH:mm')}
                                                                    </TableCell>

                                                                    <TableCell>
                                                                        {ticket.enterTime
                                                                            ? moment(ticket.enterTime).format('HH:mm')
                                                                            : '-'}
                                                                    </TableCell>

                                                                    <TableCell>
                                                                        {ticket.exitTime
                                                                            ? moment(ticket.exitTime).format('HH:mm')
                                                                            : '-'}
                                                                    </TableCell>

                                                                    <TableCell>{ticket.difference}</TableCell>

                                                                    <TableCell>
                                                                        <Chip
                                                                            label={ticket.punishment}
                                                                            size="small"
                                                                            color={ticket.punishment > 0 ? 'error' : 'default'}
                                                                            sx={{ ...((ticket.excuse || '') !== '' ? { textDecoration: 'line-through' } : {}) }}
                                                                        />
                                                                    </TableCell>

                                                                    <TableCell>
                                                                        {/* {ticket.passed ? '✔' : '✖'} */}
                                                                        {ticket.excuse || ''}
                                                                    </TableCell>

                                                                </TableRow>
                                                            ))}
                                                        </TableBody>
                                                    </Table>

                                                </AccordionDetails>
                                            </Accordion>
                                        );
                                    })}

                                </AccordionDetails>
                            </Accordion>
                        );
                    })}


                </div>
            </div>
        </PageLayout >
    );
};

export default CortesCajaReportPage;
